import { Injectable } from '@angular/core';
import { BracketCalculation } from './models/bracket-calculation.model';
import { generateMatches } from './logic/generate-matches';
import { BracketMetadata } from './models/bracket-metadata.model';
import { BracketTree, TreeMatch } from './models/bracket-tree.model';
import { Match } from './models/match.model';
import { WinnerOf } from './models/winner-of.model';
import { padWithFakes } from './logic/pad-with-fakes';
import { LoserOf } from './models/loser-of-model';
import { Round } from './models/round.model';

@Injectable({
  providedIn: 'root',
})
export class BracketService {
  calculateBracket(teams: number): BracketCalculation {
    const bracketData = new BracketMetadata(teams);
    console.log('Teams: ' + teams, bracketData);

    const bracket = generateMatches(
      teams,
      bracketData.capacityRoundSlots,
      bracketData.capacityTeamsTotal,
      bracketData.playInTeamsTotal,
      bracketData.rounds
    );

    const bracketCalc = <BracketCalculation>{
      teams,
      rounds: bracketData.rounds,
      playInTeamsTotal: bracketData.playInTeamsTotal,
      capacityTeamsTotal: bracketData.capacityTeamsTotal,
      bracket: bracket,
    };

    console.log(JSON.stringify(bracketCalc));
    // this.calcLosersBracket(bracketCalc.bracket);
    return bracketCalc;
  }

  private calcLosersBracket(winnersBracket: Round[]) {
    const loserRounds: Round[] = [];

    winnersBracket.forEach((r) => {
      if (r.alias === 'playins' && r.matches.length > 0) {
        // we have some playin matches, so we need a LB round
        const losersPlayInRound = <Round>{
          alias: r.alias,
          matches: [],
        };

        // need the same number of playin matches in the LB
        r.matches.forEach((m) => {
          losersPlayInRound.matches.push(<Match>{
            id: 99,
            slot1: new LoserOf(m),
            slot2: null,
          });
        });

        loserRounds.push(losersPlayInRound);
      }
    });

    console.log('loser rounds', loserRounds);
  }

  // UI focus only. Takes generated bracket and translates it into
  // something renderable by the UI.
  calculateTree(calc: BracketCalculation): BracketTree {
    let maxLayer = 1;
    const getPreviousMatches = (match: Match, layer: number) => {
      maxLayer = layer;
      let previousMatches = allMatches.filter((prevMatch) => {
        const prevOf1 = (match.slot1 as WinnerOf).matchId;
        const prevOf2 = (match.slot2 as WinnerOf).matchId;
        return prevMatch.id === prevOf1 || prevMatch.id === prevOf2;
      });

      previousMatches = previousMatches.map((previousMatch) => {
        return <TreeMatch>{
          ...previousMatch,
          layer,
          previous: getPreviousMatches(previousMatch, layer + 1),
        };
      });
      return previousMatches || [];
    };

    calc.bracket.reverse();
    const rootMatch = calc.bracket[0].matches[0];

    const allMatches = calc.bracket.reduce(
      (flat, val) => flat.concat(val.matches),
      []
    );
    const root = <TreeMatch>{
      ...rootMatch,
      layer: 1,
      previous: getPreviousMatches(rootMatch, 2),
    };

    const { highestPlayInMatchCount } = padWithFakes(root);

    // @TODO:
    // Experimenting with how to construct losers bracket
    // and fill it with fakes.
    // This needs to use the max height from the winners bracket as
    // the height for this one, which might be tricky since we achieve this
    // with fake matches.
    // Example: an 8 player bracket is "4 matches tall", so the losers bracket
    // must also be 4 matches tall, regardless of how many real/fake matches it has
    // const losers = {
    //   id: 7,
    //   slot1: {
    //     matchId: 5,
    //     seed: 'L3',
    //   },
    //   slot2: {
    //     matchId: 6,
    //   },
    //   layer: 1,
    //   previous: [
    //     {
    //       id: 5,
    //       slot1: {
    //         matchId: 1,
    //         seed: 'L1',
    //       },
    //       slot2: {
    //         matchId: 4,
    //         seed: 'L2',
    //       },
    //       layer: 2,
    //       previous: [
    //         {
    //           fake: true,
    //           layer: 3,
    //           previous: [],
    //         },
    //         {
    //           fake: true,
    //           layer: 3,
    //           previous: [],
    //         },
    //       ],
    //     },
    //     {
    //       fake: true,
    //       layer: 2,
    //       previous: [
    //         {
    //           fake: true,
    //           layer: 3,
    //           previous: [],
    //         },
    //         {
    //           fake: true,
    //           layer: 3,
    //           previous: [],
    //         },
    //       ],
    //     },
    //   ],
    // };

    // const modRoot = <TreeMatch>{
    //   ...root,
    //   previous: [root, losers],
    // };

    return <BracketTree>{
      highestPlayInMatchCount,
      root,
      // root: modRoot,
    };
  }

  getRounds(rounds: number) {
    // Refactor into a map
    const roundNames = [];
    for (let i = rounds - 1; i >= 0; i--) {
      switch (i) {
        case 2:
          roundNames.push('Quarter Finals');
          break;
        case 1:
          roundNames.push('Semi Finals');
          break;
        case 0:
          roundNames.push('Finals');
          break;
        default:
          roundNames.push(`Round ${rounds - i}`);
          break;
      }
    }
    return roundNames;
  }
}
